import { useCallback } from 'react';
import { sendDirectMessage } from '../services/messaging/sendDirectMessage';
import { sendHouseBroadcast } from '../services/messaging/sendHouseBroadcast';

export function useMessaging() {
  const sendDirectMessageFn = useCallback(
    (...args: Parameters<typeof sendDirectMessage>) => sendDirectMessage(...args),
    [],
  );
  const sendHouseBroadcastFn = useCallback(
    (...args: Parameters<typeof sendHouseBroadcast>) => sendHouseBroadcast(...args),
    [],
  );
  return {
    sendDirectMessage: sendDirectMessageFn,
    sendHouseBroadcast: sendHouseBroadcastFn,
  };
}
